import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { AutosuggestService } from '../autosuggest.service';

@Component({
  selector: 'app-add-combo',
  templateUrl: './add-combo.component.html',
  styleUrls: ['./add-combo.component.css']
})
export class AddComboComponent implements OnInit {

  @ViewChild('fileInput') fileInput;

  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    // This will disable dates starting from tomorrow
  };
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  headerLabel: string;
  getservicecategories: any;
  getservicelists: any;
  list: any;
  totAmt: number = 0;
  checkedItem: any = [];
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) { }

  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;

    } else {
      this.model['getyear'] = event;
    }
  }
  ngOnInit(): void {
    try {
      const sessionData = this.loginservice.getLocalSession('currentUser');
      this.currentUser = sessionData ? JSON.parse(sessionData) : {};
    } catch (error) {
      console.error('Error parsing session data:', error);
      this.currentUser = {};
      this.router.navigate(['/login']);
      return;
    }
    this.loginservice.getservicecategory('', '2', this.currentUser).subscribe(data => {
      this.getservicecategories = data['comp_details'];
    },
      error => {
        alert('Network Error getservicecategory API');
        console.error('Error fetching service categories:', error);
        this._flashMessagesService.show('Failed to load service categories. Please try again.', { cssClass: 'alert-danger' });
        this.showLoader = false;
      });
    // this.loginservice.getserviceList('').subscribe(data => {
    //   this.getservicelists = data['comp_details'];
    // },
    // error => {
    //   alert('Error in get details');
    //   this.showLoader = false;
    // });

    this.model = {
      service_category_id: '0',
      distype: ''
    };

    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }

      if (p.service_offered_id) {
        this.headerLabel = 'Edit';
        this.loginservice.getserviceListWithcategory('', this.currentUser).subscribe(data => {
          this.getservicelists = data['comp_details'];
          setTimeout(() => { this.getserviceoffered(p.service_offered_id); }, 300);
        },
          error => {
            alert('Network Error getserviceoffered API');
            this.showLoader = false;
          });
      } else {
        this.loginservice.getserviceListWithcategory('', this.currentUser).subscribe(data => {
          this.getservicelists = data['comp_details'];
        },
          error => {
            alert('Network Error getserviceListWithcategory API');
            this.showLoader = false;
          });
        this.headerLabel = 'New';
        // this.getserviceoffered('');
      }
    },
      error => {
        alert('Network Error aroutparams API');
      });
  }

  getKeyValues(obj: any): { key: string, value: any[] }[] {
    return Object.keys(obj).map(key => ({ key, value: obj[key] }));
  }


  assign_checkbox(data) {
    data.forEach((obj) => {
      this.getservicelists.forEach((items) => {
        items.service_list.forEach((item) => {
          if (item['service_list_id'] === obj['service_list_id'] && item['service_category_id'] === obj['ori_id']) {
            item.checked = true;
            if (item.checked === true) {
              // Ensure that this.checkedItem[item.service_desc] is an array
              // if (!this.checkedItem[item.service_desc]) {
              //   this.checkedItem[item.service_desc] = [];
              // }
              this.checkedItem[item.service_desc] = item;
            }
          }
        });
      });
    });
  }


  calculate() {
    if (this.model['totAmt'] > 0 && this.model['distype'] != '' && this.model['disAmt'] > '0') {
      if (this.model['distype'] === 'amount') {
        this.model['final_price'] = this.model['totAmt'] - this.model['disAmt'];
      } else if (this.model['distype'] === 'percentage') {
        this.model['final_price'] = this.model['totAmt'] - (this.model['totAmt'] / 100) * this.model['disAmt'];
      }
    } else {
      this.model['final_price'] = 0;
    }

  }

  getserviceoffered(service_offered_id) {
    this.loginservice.getserviceofferedsAddEdit(service_offered_id, '2', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            if (service_offered_id) {
              // this.model['service_offered_id'] = data['0']['service_offered_id'];
              this.model['service_category_id'] = data['data']['0']['service_category_id'];
              this.totAmt = this.model['totAmt'] = parseInt(data['data']['0']['totAmt']);
              this.model['distype'] = data['data']['0']['distype'];
              this.model['disAmt'] = data['data']['0']['disAmt'];
              this.model['start_date'] = data['data']['0']['start_date'];
              this.model['end_date'] = data['data']['0']['end_date'];
              this.assign_checkbox(data['data']);
            }
            this.showLoader = false;
          } else {
            this.model = [];
            // this._flashMessagesService.show('No Vendors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
          }
        },
        error => {
          alert('Network Error getserviceofferedsAddEdit API');
          this.showLoader = false;
        });
  }

  setCat(n) {
    if (n > 0) {
      this.model.service_category_id = n;
    } else {
      this.model.service_category_id = '';
    }
  }


  saveiserviceoffered() {
    // const checkedItems = this.getservicelists.filter(item => item.checked);
    // const checkedItems = this.getservicelists.filter(item => item.checked);
    const checkedItems = this.getservicelists.flatMap(item =>
      item.service_list.filter(items => items.checked)
    );

    if ((this.model['distype'] === '' && (this.model['disAmt'] > '0' && this.model['disAmt'] !== '')) || (this.model['distype'] !== '' && (this.model['disAmt'] <= '0' || this.model['disAmt'] === ''))) {
      this._flashMessagesService.show('Please Fill Discount Type & Amount', { cssClass: 'alert-danger' });
      return false;
    }


    if (checkedItems.length > 0) {
      this.showLoader = true;
      this.model['type'] = 2;
      this.loginservice.saveiserviceoffered(this.model, checkedItems, this.currentUser)
        .subscribe(
          data => {
            if (data['status'] === 'success') {
              this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
              this.showLoader = false;
              this.router.navigate(['/combo']);
            } else {
              this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
              this.showLoader = false;
            }
          },
          error => {
            alert('Network Error saveiserviceoffered API');
          });
    }
  }

  checkPrice(item) {
    if (item.checked) {
      // this.checkedItem = this.checkedItem.filter(item => Object.keys(item)[0] !== item.service_desc);
      Object.keys(this.checkedItem).forEach(key => {
        if (key === item.service_desc) {
          // Find the index of the element with the specified service name
          delete this.checkedItem[key];
        }
      });
      this.getprice(item, '-');
    } else {
      this.getprice(item, '+')
      this.checkedItem[item.service_desc] = item;
    }
  }


  getprice(item: any, operator: string) {
    this.loginservice.checkPrice(item, this.currentUser)
      .subscribe(
        (data: any) => {
          let value: any = data;
          if (operator === '+') {
            // Assuming data is a string representing a numeric value
            this.totAmt += parseInt(value);
          } else {
            // Handle other cases if needed
            this.totAmt -= parseInt(value);
          }
          this.model['totAmt'] = this.totAmt;
          this.calculate();
        },
        (error: any) => {
          alert('Network Error checkPrice API');
          // Handle error if necessary
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/add-combo/add-combo.component.ts